module.exports = __webpack_public_path__ + "media/images/countrysquared/hr-79f36193746ee988e3106469d3ff8626.svg";